const Notification = ({message}) => 
    <div style={{textAlign: 'center', paddingTop: '2%', fontWeight: '600', color: '#1575B4'}}>
        {message}
    </div>

export default Notification